import { UserProfile } from "../../common/types";
import { useMailboxItem } from "./mailbox/useMailboxItem";

export function useMailbox(userProfile: UserProfile) {
  return {
    userProfile,
    item: { ...useMailboxItem() },
  };
}
